import { Pill } from "@/components/report/atoms";
import { fmtMoney } from "@/lib/format";

const scoreTone = (s) => s === "High" ? "green" : s === "Medium" ? "amber" : "red";

export const BDRTable = ({ rows = [] }) => {
  if (rows.length === 0) {
    return (
      <div className="border border-dashed border-[#262626] rounded-sm p-8 text-center">
        <div className="kpi-label">/ NO BDR DATA YET</div>
      </div>
    );
  }
  return (
    <div className="border border-[#262626] rounded-sm overflow-x-auto" data-testid="bdr-performance-table">
      <table className="w-full text-sm">
        <thead className="bg-[#1F1F1F]">
          <tr>
            {["BDR", "Accounts", "Pitches Created", "Pitches Submitted", "Meetings", "Opps", "Proposals (# / $)", "Wins (# / $)", "Losses", "Conv %", "Score"].map((h, i) => (
              <th key={h} className={`text-left px-3 py-2.5 kpi-label whitespace-nowrap ${i > 0 ? "text-right" : ""}`}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.bdr_name} className={i % 2 ? "bg-[#0A0A0A]" : "bg-[#141414]"} data-testid={`bdr-row-${i}`}>
              <td className="px-3 py-2.5 text-white font-display tracking-tight">{r.bdr_name}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.accounts_managed}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.pitches_created}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.pitches_submitted}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.meetings}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.opportunities}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">
                {r.proposals} <span className="text-[#525252]">/</span> {fmtMoney(r.proposal_value)}
              </td>
              <td className="px-3 py-2.5 text-right font-mono-data">
                <span className="text-[#32D74B]">{r.wins}</span> <span className="text-[#525252]">/</span> <span className="text-[#32D74B]">{fmtMoney(r.wins_value)}</span>
              </td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#FF453A]">{r.losses}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-white">{r.conversion_rate}%</td>
              <td className="px-3 py-2.5 text-right">
                <Pill tone={scoreTone(r.productivity_score)}>{r.productivity_score}</Pill>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BDRTable;
